import * as types from "../../actions/actionTypes"
const initialState = {
  loading:true,
  error:false,
  data: { data: [], links: {}, message: [], meta: {}, chart_data:[] }
};

const PettyCashierOverallCost = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_GET_OVERALL_COST_REQUEST:
      return { ...state, loading: true, error: false };
    case types.PETTY_CASHIER_GET_OVERALL_COST_SUCCESS:
      return { ...state, loading: false, data: action.payLoad };
    case types.PETTY_CASHIER_GET_OVERALL_COST_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default PettyCashierOverallCost;